export * from './invoice';

export const isInputSanitized = (input: string): boolean => {
  const unsafe = ['&', '<', '>', '"', "'", '/', '`', '='];
  return !unsafe.some(char => input.includes(char));
};
